module.exports = __webpack_public_path__ + "static/media/loading_car.f11589d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/VehicleImageWithPlaceholder/loading_car.svg
// module id = 1601
// module chunks = 7